@if (!item) {
  <div class="empty-state">
    @if (section() === 'projects') {
      <app-no-content-stub imageSrc="assets/placeholders/placeholder-tasks.svg" [size]="124">
        <p class="text-base font-medium text-gray-900 text-center">No project selected</p>
        <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" [gap]="4" (click)="handleNewProject()">
          <app-icon name="project-board" />
          Start a new project
        </app-button2>
      </app-no-content-stub>
    } @else {
      <app-no-content-stub imageSrc="assets/placeholders/placeholder-tasks.svg" [size]="124">
        <p class="text-base font-medium text-gray-900 text-center">No task selected</p>
        <app-button2 class="[&>button]:bg-offwhite" appearance="secondary" size="m" [gap]="4" (click)="handleNewTask()">
          <app-icon name="tasking" />
          Start a new task
        </app-button2>
      </app-no-content-stub>
    }
  </div>
}

@if (Task.isTask(item)) {
  <app-task-form
    [task]="item"
    id="task-form"
    (close)="handleFormClose($event)"
    />
  } @else if (Project.isProject(item)) {
    <app-project-form
      [project]="item"
      id="project-form"
      (close)="handleFormClose($event)"
      />
    }
